<template lang="pug">
.rate
  v-text-field.text-sm.round-xl(v-if="item.editable && allowedPriceEdit" v-model.number="rate" outlined hide-details dense type="number" :prefix="$currency.symbol" @input="onChange")
  div(v-else :class="{ 'clickable':isClickable }")
    span.font-medium.danger500--text(v-if="item.error") {{ item.rate | displayPrice }}
    span(v-else) {{ item.rate | displayPrice }}
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    allowedPriceEdit: {
      type: Boolean
    }
  },
  data() {
    return {
      rate: null
    }
  },
  mounted () {
    this.rate = (this.item.rate/this.$currency.multiplier).toFixed(this.$currency.exponent)
  },
  computed: {
    isClickable () {
      return this.allowPriceEdit
    }
  },
  methods: {
    onChange(value) {
      this.$set(this.item, 'rate', parseInt(parseFloat(value).toFixed(this.$currency.exponent).replace('.', '')))
      this.$emit('changed', this.item)
    }
  },
};
</script>

<style lang="scss" scoped>
</style>